var _style, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 514.8 122.7",
    style: {
      enableBackground: "new 0 0 514.8 122.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#3B2E85;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#60E4FF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 122.7,
    height: 122.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.6,
    y: 51.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -25.3751 61.2067)",
    style: {
      fill: "#3B2E85"
    },
    className: "st1",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 51.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -38.4603 30.05)",
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.1,
    y: 51.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -12.4195 92.6898)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.2499 39.0947)",
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 73.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -47.5867 52.1541)",
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.3,
    y: 8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 18.306 79.2782)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.4,
    y: 29.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.519 70.1551)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 73.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -34.5743 83.5248)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.7,
    y: 95.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -43.6009 105.3092)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 7.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -7.2212 17.3067)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 95.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -69.4576 42.9112)",
    style: {
      fill: "#60E4FF"
    },
    className: "st3",
    width: 19.1,
    height: 19.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M148.9,52.8l9.6-16.3c-1.8-0.6-3.2-1.6-4.5-2.8s-2.2-2.7-3-4.4c-0.7-1.7-1.1-3.7-1.1-5.9v-8.3h7.5V24 c0,1.1,0.2,2.2,0.7,3.1c0.5,1,1.1,1.7,1.9,2.3c0.9,0.6,1.8,1,2.9,1.1l8.9-15.3h8.5l-9.6,15.9c1.9,0.5,3.7,1.4,5.2,2.6 c1.5,1.2,2.6,2.7,3.4,4.6c0.8,1.8,1.2,3.9,1.2,6.2v8.3H173v-8.8c0-1.9-0.6-3.4-1.8-4.7c-1.2-1.3-2.8-1.9-5.1-1.9l-9,15.4 L148.9,52.8L148.9,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M186.4,52.8v-6.8h15.8c0.8,0,1.5-0.2,2.1-0.6c0.6-0.4,1.2-0.9,1.6-1.6s0.6-1.4,0.6-2.2 c0-0.8-0.2-1.6-0.6-2.2c-0.4-0.7-0.9-1.2-1.6-1.6c-0.6-0.4-1.4-0.6-2.1-0.6H196c-2,0-4-0.4-5.6-1.3c-1.7-0.9-3-2.1-4-3.8 c-1-1.6-1.5-3.6-1.5-5.9c0-2.3,0.5-4.2,1.5-5.9c1-1.7,2.2-3,3.8-3.9c1.7-0.9,3.4-1.4,5.4-1.4h16V22h-15.3 c-0.7,0-1.4,0.2-1.9,0.6c-0.6,0.4-1.1,0.9-1.4,1.5c-0.3,0.6-0.5,1.3-0.5,2.1c0,0.8,0.2,1.4,0.5,2.1c0.3,0.6,0.8,1.1,1.4,1.5 c0.6,0.4,1.3,0.5,1.9,0.5h6.3c2.2,0,4.3,0.5,5.9,1.3c1.7,0.9,3,2.2,3.9,3.8c1,1.6,1.4,3.5,1.4,5.7c0,2.6-0.5,4.7-1.5,6.5 c-1,1.8-2.2,3.2-3.9,4.1c-1.7,0.9-3.4,1.4-5.4,1.4L186.4,52.8L186.4,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M218.4,52.8v-6.8h6.6V22h-6.6v-6.8h20.7V22h-6.6v24h6.6v6.8H218.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M158.2,100.9c-1.8,0-3.2-0.4-4.7-0.9c-1.4-0.6-2.5-1.4-3.5-2.4c-1-1-1.8-2.2-2.2-3.6 c-0.5-1.4-0.8-2.8-0.8-4.3c0-1.5,0.3-3,0.8-4.3c0.5-1.4,1.3-2.5,2.2-3.6c1-1.1,2.1-1.8,3.5-2.4c1.4-0.6,2.9-0.9,4.7-0.9h3.4v4.1 h-3.3c-1,0-1.9,0.2-2.7,0.6c-0.9,0.4-1.6,0.9-2.1,1.5c-0.6,0.6-1.1,1.4-1.5,2.3c-0.3,0.9-0.5,1.8-0.5,2.8c0,1,0.2,2,0.5,2.8 c0.3,0.9,0.8,1.6,1.5,2.3s1.4,1.1,2.1,1.5c0.9,0.4,1.8,0.6,2.7,0.6h3.3v4.1h-3.4V100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M164.7,100.9V89.3c0-1.5,0.4-2.6,1.2-3.4s1.9-1.2,3.3-1.2h4.4v3.8h-3.7c-0.3,0-0.5,0.1-0.7,0.3 c-0.2,0.2-0.3,0.4-0.3,0.7V101L164.7,100.9L164.7,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M183.7,101.3c-1.7,0-3.1-0.4-4.4-1.1c-1.3-0.8-2.3-1.8-3.1-3.1s-1.2-2.8-1.2-4.4c0-1.6,0.4-3.1,1.2-4.4 c0.8-1.3,1.8-2.3,3.1-3.1c1.3-0.8,2.7-1.1,4.4-1.1c1.7,0,3.1,0.4,4.4,1.1c1.3,0.8,2.3,1.8,3.1,3.1c0.8,1.3,1.2,2.8,1.2,4.4 c0,1.6-0.4,3.1-1.2,4.4c-0.8,1.3-1.8,2.3-3.1,3.1C186.8,101,185.3,101.3,183.7,101.3z M183.7,97.6c0.9,0,1.7-0.2,2.2-0.6 c0.7-0.4,1.2-1,1.5-1.7c0.4-0.7,0.5-1.5,0.5-2.4s-0.2-1.7-0.5-2.4c-0.4-0.7-0.9-1.3-1.5-1.7c-0.7-0.4-1.4-0.6-2.2-0.6 c-0.9,0-1.7,0.2-2.2,0.6c-0.7,0.4-1.2,1-1.5,1.7s-0.5,1.5-0.5,2.4s0.2,1.7,0.5,2.4c0.4,0.7,0.9,1.3,1.5,1.7 C182,97.4,182.8,97.6,183.7,97.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M195.5,100.9v-3.7h7.8c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.5s0.2-0.4,0.2-0.6 c0-0.3-0.1-0.5-0.2-0.7s-0.3-0.3-0.5-0.5c-0.2-0.1-0.4-0.2-0.7-0.2h-3c-1.1,0-1.9-0.2-2.7-0.5c-0.8-0.3-1.5-0.9-1.9-1.6 c-0.5-0.7-0.8-1.7-0.8-2.9c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.8-1.8c0.8-0.5,1.6-0.7,2.5-0.7h7.5v3.8h-7.1 c-0.3,0-0.6,0.1-0.9,0.3c-0.2,0.2-0.4,0.5-0.4,0.8s0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.3,0.9,0.3h3c1.2,0,2.1,0.2,3,0.5 c0.9,0.4,1.5,0.9,1.9,1.7c0.5,0.8,0.7,1.7,0.7,3c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.1,1.4-1.8,1.9s-1.7,0.7-2.6,0.7L195.5,100.9 L195.5,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M212.2,100.9v-3.7h7.8c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.3,0.5-0.5c0.1-0.2,0.2-0.4,0.2-0.6 c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.5-0.5c-0.2-0.1-0.4-0.2-0.7-0.2h-2.9c-1.1,0-1.9-0.2-2.7-0.5 c-0.8-0.3-1.5-0.9-1.9-1.6s-0.8-1.7-0.8-2.9c0-0.9,0.2-1.8,0.7-2.5c0.5-0.8,1.1-1.4,1.8-1.8c0.8-0.5,1.6-0.7,2.5-0.7h7.5v3.8 h-7.1c-0.3,0-0.6,0.1-0.9,0.3c-0.2,0.2-0.4,0.5-0.4,0.8s0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.3,0.9,0.3h3c1.2,0,2.1,0.2,3,0.5 c0.9,0.4,1.5,0.9,1.9,1.7c0.5,0.8,0.7,1.7,0.7,3c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.1,1.4-1.8,1.9s-1.7,0.7-2.6,0.7L212.2,100.9 L212.2,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M237.5,100.9v-2.1h9.5c0.9,0,1.6-0.2,2.2-0.6c0.6-0.4,1.1-0.9,1.4-1.6c0.3-0.7,0.5-1.3,0.5-2s-0.2-1.4-0.5-2 c-0.3-0.6-0.8-1.1-1.4-1.5c-0.6-0.4-1.3-0.6-2.1-0.6h-4.4c-1.3,0-2.3-0.3-3.2-0.8c-0.9-0.5-1.7-1.2-2.1-2.1 c-0.5-0.9-0.8-1.9-0.8-3c0-1.1,0.3-2.1,0.8-3.1c0.5-0.9,1.2-1.7,2.1-2.3c0.9-0.6,1.9-0.9,3.2-0.9h9.2v2.1h-9.1 c-0.8,0-1.6,0.2-2.1,0.6c-0.6,0.4-1.1,0.9-1.4,1.5c-0.3,0.6-0.5,1.2-0.5,1.9s0.2,1.3,0.5,1.9c0.3,0.6,0.8,1.1,1.4,1.5 c0.6,0.4,1.3,0.6,2.1,0.6h4.4c1.4,0,2.4,0.3,3.3,0.8c0.9,0.5,1.6,1.3,2,2.2c0.5,0.9,0.7,1.9,0.7,3c0,1.2-0.3,2.3-0.8,3.3 c-0.5,1-1.2,1.8-2.1,2.4c-0.9,0.6-2,0.9-3.3,0.9L237.5,100.9L237.5,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M258.9,107.5v-2h7.6c1.1,0,1.8-0.3,2.3-0.9s0.8-1.4,0.8-2.4v-3.8l0,0c-0.6,0.9-1.5,1.6-2.4,2.1 c-1,0.5-2,0.7-3,0.7c-1.3,0-2.4-0.3-3.5-0.9c-1.1-0.6-1.8-1.4-2.5-2.5c-0.6-1.1-0.9-2.4-0.9-3.9v-9.3h2.2v9.2 c0,1.2,0.3,2.1,0.8,2.9c0.5,0.8,1.2,1.4,1.8,1.8c0.8,0.4,1.6,0.6,2.4,0.6c0.9,0,1.8-0.2,2.5-0.6c0.8-0.4,1.4-1,1.8-1.8 c0.5-0.8,0.8-1.8,0.8-2.9v-9.3h2.2v17.8c0,1.5-0.4,2.8-1.3,3.7s-2,1.4-3.6,1.4L258.9,107.5L258.9,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M276.5,100.9v-2h7.5c0.7,0,1.2-0.1,1.7-0.4c0.5-0.3,0.8-0.6,1-1.1s0.4-0.9,0.4-1.4c0-0.5-0.1-0.9-0.3-1.3 c-0.2-0.4-0.5-0.7-0.9-1c-0.4-0.3-0.9-0.4-1.5-0.4H281c-1.1,0-1.9-0.2-2.6-0.5c-0.8-0.4-1.3-0.9-1.7-1.5 c-0.4-0.7-0.6-1.4-0.6-2.3c0-0.8,0.2-1.5,0.6-2.2c0.4-0.7,0.9-1.2,1.6-1.7c0.7-0.4,1.5-0.6,2.4-0.6h7.2v2h-7 c-0.8,0-1.5,0.3-1.9,0.8s-0.7,1.1-0.7,1.7c0,0.6,0.2,1.2,0.7,1.7s1.2,0.7,2,0.7h3.1c1.2,0,2,0.2,2.8,0.6c0.8,0.4,1.4,0.9,1.8,1.6 c0.4,0.7,0.6,1.5,0.6,2.4c0,0.8-0.2,1.6-0.6,2.4c-0.4,0.8-1,1.4-1.8,1.8c-0.7,0.5-1.6,0.7-2.5,0.7L276.5,100.9L276.5,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M290.8,86.6v-2h10.9v2H290.8z M298.1,100.9c-1.5,0-2.5-0.4-3.3-1.3s-1.2-2-1.2-3.4V80.4h2.2v15.5 c0,0.9,0.2,1.7,0.7,2.2s1.2,0.8,2,0.8h3.1v2H298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M312.9,100.9c-1.8,0-3.2-0.3-4.6-1c-1.4-0.7-2.4-1.6-3.2-2.8c-0.8-1.2-1.2-2.7-1.2-4.4c0-1.6,0.3-3,1-4.3 c0.6-1.3,1.5-2.3,2.6-3.1c1.2-0.8,2.4-1.2,4-1.2s2.9,0.4,4,1.1s1.9,1.7,2.4,2.9c0.6,1.2,0.9,2.6,0.9,4.1c0,0.2,0,0.5,0,0.7 c0,0.3-0.1,0.5-0.1,0.7h-12.5c0.1,1.2,0.4,2.2,1,3c0.6,0.8,1.4,1.4,2.3,1.8c1,0.4,2,0.6,3.1,0.6h4.1v2L312.9,100.9L312.9,100.9z  M306.3,92h10.3c0-0.4,0-0.9-0.1-1.4c-0.1-0.5-0.2-1-0.5-1.6c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.9-0.8-1.5-1 c-0.6-0.3-1.4-0.4-2.1-0.4c-0.8,0-1.6,0.2-2.1,0.5c-0.7,0.3-1.2,0.8-1.7,1.4s-0.8,1.2-1,1.9C306.4,90.6,306.3,91.3,306.3,92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M322.7,100.9v-9.8c0-1.3,0.3-2.4,0.9-3.5c0.6-1,1.4-1.9,2.3-2.5c1.1-0.6,2.2-0.9,3.7-0.9 c0.8,0,1.5,0.1,2.2,0.3c0.8,0.2,1.5,0.6,2.1,1.2c0.7,0.5,1.2,1.3,1.6,2.3l0,0c0.4-1,0.9-1.7,1.6-2.3c0.7-0.5,1.4-0.9,2.1-1.2 c0.8-0.2,1.6-0.3,2.2-0.3c1.5,0,2.6,0.3,3.7,0.9c1.1,0.6,1.8,1.5,2.3,2.5c0.6,1,0.8,2.2,0.8,3.5v9.8h-2.1v-9.8 c0-1-0.2-1.8-0.6-2.5c-0.4-0.7-1-1.3-1.7-1.8c-0.7-0.5-1.5-0.7-2.4-0.7c-0.9,0-1.8,0.2-2.4,0.7c-0.8,0.4-1.3,1-1.8,1.8 s-0.7,1.6-0.7,2.5v9.8h-2.2v-9.8c0-0.9-0.2-1.8-0.7-2.5c-0.5-0.8-1-1.3-1.8-1.8c-0.7-0.4-1.6-0.7-2.4-0.7s-1.7,0.2-2.4,0.7 c-0.7,0.4-1.3,1-1.7,1.8c-0.4,0.8-0.6,1.6-0.6,2.5v9.8H322.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M360.7,100.9v-2.1h4.4V80.5h-4.4v-2.1h11v2.1h-4.4v18.3h4.4v2.1H360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M375.7,100.9v-9.5c0-1.5,0.3-2.8,1-3.9c0.7-1.1,1.6-1.9,2.6-2.5s2.3-0.9,3.7-0.9s2.6,0.3,3.7,0.9 c1.1,0.6,1.9,1.4,2.6,2.5c0.7,1.1,1,2.4,1,3.9v9.5H388v-9.4c0-1.1-0.2-2.1-0.7-2.9s-1.1-1.4-1.8-1.9c-0.8-0.4-1.7-0.6-2.5-0.6 c-0.9,0-1.7,0.2-2.4,0.6c-0.8,0.4-1.4,1-1.8,1.8s-0.7,1.8-0.7,2.9v9.4L375.7,100.9L375.7,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M393.2,86.6v-2h10.9v2H393.2z M400.6,100.9c-1.5,0-2.5-0.4-3.3-1.3s-1.2-2-1.2-3.4V80.4h2.2v15.5 c0,0.9,0.2,1.7,0.7,2.2s1.2,0.8,2,0.8h3.1v2H400.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M415.4,100.9c-1.8,0-3.2-0.3-4.6-1s-2.4-1.6-3.2-2.8c-0.8-1.2-1.2-2.7-1.2-4.4c0-1.6,0.3-3,1-4.3 c0.6-1.3,1.5-2.3,2.6-3.1c1.2-0.8,2.4-1.2,4-1.2s2.9,0.4,4,1.1s1.9,1.7,2.4,2.9c0.6,1.2,0.9,2.6,0.9,4.1c0,0.2,0,0.5,0,0.7 c0,0.3-0.1,0.5-0.1,0.7h-12.5c0.1,1.2,0.4,2.2,1,3s1.4,1.4,2.3,1.8c1,0.4,2,0.6,3.1,0.6h4.1v2L415.4,100.9L415.4,100.9z  M408.8,92h10.3c0-0.4,0-0.9-0.1-1.4c-0.1-0.5-0.2-1-0.5-1.6c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.9-0.8-1.5-1 c-0.6-0.3-1.4-0.4-2.1-0.4c-0.8,0-1.6,0.2-2.1,0.5c-0.7,0.3-1.2,0.8-1.7,1.4s-0.8,1.2-1,1.9C408.9,90.6,408.8,91.3,408.8,92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M427.7,107.5v-2h7.6c1.1,0,1.8-0.3,2.3-0.9s0.8-1.4,0.8-2.4v-4.7h-0.1c-0.4,0.6-0.9,1.2-1.5,1.8 s-1.3,1.1-2,1.4c-0.8,0.4-1.8,0.5-2.7,0.5c-1.6,0-2.9-0.4-4.1-1.1c-1.2-0.7-2-1.8-2.7-3c-0.7-1.2-1-2.8-1-4.4 c0-1.6,0.3-3.1,1-4.3c0.7-1.3,1.6-2.3,2.8-3c1.3-0.7,2.6-1.1,4.4-1.1c1.7,0,3,0.4,4.3,1.1c1.3,0.7,2.1,1.7,2.8,3 c0.7,1.3,1.1,2.8,1.1,4.4v9.6c0,1.5-0.5,2.8-1.4,3.7c-0.9,0.9-2,1.4-3.6,1.4L427.7,107.5L427.7,107.5z M432.4,99.3 c1.2,0,2.2-0.3,3.1-0.9c0.9-0.6,1.6-1.4,2.1-2.3c0.5-1,0.8-2.1,0.8-3.4c0-1.3-0.3-2.4-0.8-3.4s-1.2-1.8-2-2.3 c-0.9-0.6-1.9-0.9-3.1-0.9c-1.2,0-2.2,0.3-3.1,0.9c-0.9,0.6-1.6,1.4-2,2.4s-0.7,2.1-0.7,3.4c0,1.2,0.2,2.3,0.7,3.3 c0.5,1,1.2,1.8,2,2.3C430.2,99,431.2,99.3,432.4,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M445.3,100.9V89.3c0-1.5,0.4-2.6,1.2-3.4s1.9-1.2,3.3-1.2h2.7v2h-2.3c-0.9,0-1.7,0.3-2,0.8 c-0.5,0.5-0.7,1.2-0.7,2.2v11.4h-2.1V100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M462.2,101.4c-1.7,0-3-0.4-4.1-1.2c-1.2-0.8-2-1.8-2.6-3.1s-0.9-2.8-0.9-4.4c0-1.6,0.3-3.1,1-4.4 c0.7-1.3,1.7-2.3,2.8-3.1c1.3-0.8,2.7-1.1,4.5-1.1c1.7,0,3.1,0.4,4.3,1.1c1.2,0.8,2.1,1.8,2.8,3c0.7,1.2,1,2.7,1,4.3v8.3h-2.1 v-3.7h-0.1c-0.3,0.6-0.8,1.3-1.4,1.9c-0.6,0.6-1.3,1.2-2.1,1.6C464.4,101.2,463.4,101.4,462.2,101.4z M462.7,99.4 c1.2,0,2.2-0.3,3.1-0.9c0.9-0.6,1.7-1.4,2.1-2.4c0.5-1,0.8-2.2,0.8-3.5c0-1.3-0.2-2.4-0.7-3.4c-0.5-1-1.2-1.8-2-2.3 c-0.9-0.6-1.9-0.9-3.1-0.9c-1.3,0-2.3,0.3-3.2,0.9c-0.9,0.6-1.6,1.4-2,2.4s-0.7,2.2-0.7,3.5c0,1.2,0.2,2.3,0.7,3.3 c0.5,1,1.2,1.8,2,2.4C460.4,99.1,461.4,99.4,462.7,99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M473.9,86.6v-2h10.9v2H473.9z M481.2,100.9c-1.5,0-2.5-0.4-3.3-1.3s-1.2-2-1.2-3.4V80.4h2.2v15.5 c0,0.9,0.2,1.7,0.7,2.2c0.5,0.5,1.2,0.8,2,0.8h3.1v2H481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M495.3,101.4c-1.7,0-3-0.4-4.3-1.1c-1.3-0.8-2.2-1.8-2.9-3.1s-1.1-2.8-1.1-4.4s0.4-3.1,1.1-4.4 c0.7-1.3,1.7-2.3,2.9-3.1c1.3-0.8,2.7-1.1,4.3-1.1c1.7,0,3,0.4,4.3,1.1c1.3,0.8,2.2,1.8,2.9,3.1c0.7,1.3,1.1,2.8,1.1,4.4 s-0.4,3.1-1.1,4.4c-0.7,1.3-1.7,2.3-2.9,3.1C498.3,101,497,101.4,495.3,101.4z M495.3,99.4c1.2,0,2.2-0.3,3.1-0.9 c0.9-0.6,1.7-1.4,2.1-2.4c0.5-1,0.8-2.1,0.8-3.4c0-1.3-0.3-2.4-0.8-3.4s-1.3-1.8-2.1-2.4c-0.9-0.6-1.9-0.9-3.1-0.9 c-1.2,0-2.2,0.3-3.2,0.9c-0.9,0.6-1.7,1.4-2.1,2.4s-0.8,2.1-0.8,3.4c0,1.3,0.3,2.4,0.8,3.4c0.5,1,1.3,1.8,2.1,2.4 C493.1,99.1,494.2,99.4,495.3,99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M507.6,100.9V89.3c0-1.5,0.4-2.6,1.2-3.4s1.9-1.2,3.3-1.2h2.7v2h-2.3c-0.9,0-1.7,0.3-2,0.8 c-0.5,0.5-0.7,1.2-0.7,2.2v11.4h-2.1V100.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    className: "st2",
    d: "M258.3,14.7v2H256v6.5h-2.4v-6.5h-2.3v-2H258.3z M263.9,18.6c0.1,0.2,0.1,0.3,0.2,0.5 c0.1,0.2,0.1,0.3,0.2,0.5c0.1-0.2,0.1-0.3,0.2-0.5s0.1-0.3,0.2-0.5l1.9-3.6c0.1-0.2,0.2-0.3,0.3-0.3c0.1,0,0.3,0,0.5,0h2.1v8.5 h-2.1v-4.2l0.2-1.4l-2.1,4.2c-0.2,0.3-0.4,0.5-0.8,0.5h-0.3c-0.4,0-0.7-0.2-0.8-0.5l-2.1-4.2l0.2,1.3v4.2h-2.1v-8.5h2.1 c0.2,0,0.4,0,0.5,0s0.2,0.1,0.3,0.3L263.9,18.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmW);
export default __webpack_public_path__ + "static/media/logo-sm-w.1a32b216d526e1f629a5e0d4d4567073.svg";
export { ForwardRef as ReactComponent };